import React, { useState, useEffect, } from 'react';
import PropTypes from 'prop-types';
import _, { isObject, } from 'lodash';
import { money, } from '@payit/payit-formatter';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';
import PaymentGatewayService from '../../../service/PaymentGatewayService';
import AutopayService from '../../../service/AutopayService';

const AutopayDetail = ({ selectedAccount, }) => {
  const [ paymentAccount, setPaymentAccount, ] = useState(null);
  const [ upcomingPayment, setUpcomingPayment, ] = useState(null);

  useEffect(() => {
    const customerId = selectedAccount.customerId;
    PaymentGatewayService.paymentAccounts.getPaymentAccountsByCustomerId(customerId)
      .then(response => {
        const paymentAccounts = response.data.paymentAccount;
        if (paymentAccounts && paymentAccounts.length > 0) {
          const selectedPaymentAccount = paymentAccounts.find(account => account.id === selectedAccount.paymentAccountId);
          setPaymentAccount(selectedPaymentAccount);
        }
      });
  }, [ selectedAccount.customerId, selectedAccount.paymentAccountId, ]);

  useEffect(() => {
    AutopayService.getUpcomingPayment({
      serviceOfferingId: selectedAccount.serviceOfferingId,
      accountId: selectedAccount.accountId,
    }).then(response => {
      const { payable, } = response.data;
      if (payable) {
        setUpcomingPayment(payable);
      }
    });
  }, [ selectedAccount.serviceOfferingId, selectedAccount.accountId, ]);

  const renderAccountInformation = () => {
    const formattedAccount = Object.keys(selectedAccount)
      .filter(key => !!selectedAccount[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = selectedAccount[key];
        return obj;
      }, {});

    const items = VerticalLabelList.toList(formattedAccount);
    const exclusions = [];

    return (
      <FieldSet title="Autopay Account" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  const renderPaymentAccountInformation = () => {
    const formattedPaymentAccount = Object.keys(paymentAccount)
      .filter(key => !!paymentAccount[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = paymentAccount[key];
        return obj;
      }, {});

     
    const items = VerticalLabelList.toList(formattedPaymentAccount);
    if (isObject(items)) {
      items.forEach((item) => {
        if (item.label.value === 'Created At' || item.label.value === 'Updated At') {
          item.data.display = formatDate(item.data.value);
        }
      });
    }
     
    const exclusions = [];

    return (
      <FieldSet title="Payment Method" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  const renderUpcomingPaymentInformation = () => {
    const exclusions = [];
    const items = VerticalLabelList.toList({
      'Autopay Bill Id': upcomingPayment.autopayBillId,
      'Payment Status': upcomingPayment.status,
      'Due Date': upcomingPayment.payable ? upcomingPayment.payable.dueDate : '',
      'Scheduled Date': upcomingPayment.scheduledDate,
      'Payment Amount': upcomingPayment.payable ? money.printMoney(upcomingPayment.payable.balanceDue) : '',
    });

    return (
      <FieldSet title="Upcoming Payment" style={{ maxHeight: '400px', }}>
        {upcomingPayment.status === 'SCHEDULED'
          ? <VerticalLabelList items={items} exclusions={exclusions} />
          : <p>No upcoming payments scheduled.</p>}
      </FieldSet>
    );
  };

  return (
    <>
      {renderAccountInformation()}
      {paymentAccount && renderPaymentAccountInformation()}
      {upcomingPayment && renderUpcomingPaymentInformation()}
    </>
  );
};

function formatDate(epochMillis) {
  return epochMillis ? new Date(epochMillis * 1000) : '';
}

AutopayDetail.propTypes = {
  selectedAccount: PropTypes.instanceOf(Object).isRequired,
};

export default AutopayDetail;
